import { render, staticRenderFns } from "./kpis-legend.component.vue?vue&type=template&id=574893a3&scoped=true"
import script from "./kpis-legend.component.vue?vue&type=script&lang=ts"
export * from "./kpis-legend.component.vue?vue&type=script&lang=ts"
import style0 from "./kpis-legend.component.vue?vue&type=style&index=0&id=574893a3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "574893a3",
  null
  
)

export default component.exports